<ng-container *ngIf="hasText()">
  <ion-item>
    <ion-icon name="document-text" slot="start" size="large"></ion-icon>
    <ion-label class="ion-text-wrap">
      <h2>{{ callcard.note.Text }}</h2>
    </ion-label>
  </ion-item>
</ng-container>
